<template>
  <input
    type="checkbox"
    class="tw-h-5 tw-w-5 tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500"
    :class="classes"
    :indeterminate="indeterminate"
    :disabled="disabled"
    :readonly="readonly"
    @click="handleClick"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import { computed, toRefs } from "vue";

const props = withDefaults(
  defineProps<{
    indeterminate: boolean;
    disabled?: boolean;
    readonly?: boolean;
  }>(),
  {
    disabled: false,
    readonly: false,
  },
);

const { indeterminate, disabled, readonly } = toRefs(props);

const focusClasses = "focus:tw-ring-secondary-500 focus:tw-ring-offset-white";

const disabledClasses =
  "disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100";

const readonlyClasses =
  "read-only:tw-cursor-not-allowed read-only:tw-border-dorian-gray-100 read-only:tw-text-dorian-gray-100 read-only:checked:tw-border-0";

const handleClick = (e: MouseEvent) => {
  if (readonly.value) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
};

const classes = computed(() => {
  if (props.disabled) {
    return disabledClasses;
  }
  if (props.readonly) {
    return readonlyClasses;
  }
  return `tw-cursor-pointer ${focusClasses}`;
});
</script>
